import { render, staticRenderFns } from "./ProficiencyDetail.vue?vue&type=template&id=2a238056&"
import script from "./ProficiencyDetail.vue?vue&type=script&lang=js&"
export * from "./ProficiencyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports